<template>
  <nav
    class="relative flex items-center justify-between flex-wrap md:py-6 h-16 lg:h-20"
  >
    <div class="flex items-center flex-shrink-0 text-white pl-6 md:pr-6">
      <router-link to="/" class="flex">
        <img src="/spyows.png" alt="spyows logo" style="width:40px" />
        <!-- <span class="font-semibold text-xl tracking-tight ml-1">SPYOWS</span> -->
      </router-link>
    </div>
    <div
      class="bg-black md:bg-transparent md:bg-opacity-75 w-fullblock md:flex md:items-center md:w-auto ml-auto px-6 md:pl-0"
    >
      <div
        class="lg:hidden"
        :class="{ fixed: isOpen, absolute: !isOpen }"
        style="top: 20px; right: 65px; z-index:100"
      >
        <button
          @click="$store.commit('TOGGLESIDEBAR')"
          class="lg:hidden flex items-center px-3 py-1 border rounded text-custom border-custom hover:text-white focus:border-white focus:outline-none text-lg"
        >
          <i v-if="!isOpen" class="bx bx-menu"></i>
          <i v-else class="bx bx-x"></i>
        </button>
      </div>
      <h3 class="text-custom text-2xl font-medium hidden lg:block">
        My Dashbaord
      </h3>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Header",
  computed: {
    ...mapGetters(["isOpen"])
  }
};
</script>

<style lang="postcss" scoped>
nav {
  z-index: 99999;
}
</style>
